module.exports = __webpack_public_path__ + "img/asp.net-mvc.5787e6f2.png";